import React from 'react';
import { connect } from 'react-redux';
import { logout } from 'redux-implicit-oauth2';
import { Avatar, Button, TabItem as Tab } from 'rebass';
import { keys } from 'ramda';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import matchSorter from 'match-sorter';
import getTextWidth from 'text-width';
import { blue } from '../colours';
import Header from '../Header';
import SubHeading from './SubHeading';
import IdleTimer from 'react-idle-timer';

export class Dashboard extends React.Component {
  state = {};

  getResizerProps = (_finalState, _, column, reactTable) => ({
    onDoubleClick: _event => {
      const pageRows = reactTable.state.sortedData.slice(
        0,
        reactTable.state.pageSize,
      );

      const columnWidth =
        1.35 * Math.max(...pageRows.map(row => getTextWidth(row[column.id])));

      this.setState({
        [column.id]:
          this.state[column.id] !== undefined ? undefined : columnWidth,
      });
    },
  });

  render() {
    const {
      meta: { timeRange, user },
      payload: { items },
      error,
      isCustomerListLoading,
      handleLogout,
      history,
    } = this.props;

    const columns = keys(items[0]).map(key => ({
      accessor: key,
      Header: key.toUpperCase().replace(/_/g, ' '),
      filterable: true,
      filterAll: true,
      resizeable: true,
      filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, {
          keys: [key],
          threshold: matchSorter.rankings.CONTAINS,
        }),
      width: this.state[key],
    }));

    return (
      <div>
        <IdleTimer
          onIdle={logoutAndRedirect(handleLogout, history)}
          timeout={60 * 1000 * 15}
        />
        <ReactTable
          noDataText={error}
          loading={isCustomerListLoading}
          data={items}
          columns={columns}
          defaultPageSize={50}
          defaultSorted={[
            {
              id: 'total_pallets_produced',
              desc: true,
            },
          ]}
          className="-striped -highlight"
          style={{ height: 'calc(100vh - 120px)' }}
          getResizerProps={this.getResizerProps}>
          {(state, makeTable) => {
            const totalNumberOfPallets = state.sortedData.reduce(
              (x, { total_pallets_produced: y }) => x + y,
              0,
            );
            const numberOfSites = new Set(
              state.sortedData.map(x => x.pm_site_name),
            ).size;

            return (
              <React.Fragment>
                <Header
                  name={user.givenName}
                  subHeading={
                    <SubHeading
                      timeRange={timeRange}
                      numberOfSites={numberOfSites}
                      totalNumberOfPallets={totalNumberOfPallets}
                    />
                  }>
                  <Tab
                    active
                    fontSize={2}
                    color={blue}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://docs.google.com/document/d/1KgiVVLy814OUsb0zOYsBFjWR932anmP2-d-E44P282M/edit#">
                    Help
                  </Tab>
                  <Avatar src={user.picture} size={64} />
                  <Button
                    onClick={logoutAndRedirect(handleLogout, history)}
                    bg={blue}>
                    Logout
                  </Button>
                </Header>
                {makeTable()}
              </React.Fragment>
            );
          }}
        </ReactTable>
      </div>
    );
  }
}

function logoutAndRedirect(handleLogout, history) {
  return function() {
    handleLogout();
    return history.push('/');
  };
}

function mapStateToProps({ dashboard }) {
  return dashboard;
}

export default connect(mapStateToProps, { handleLogout: logout })(Dashboard);



// WEBPACK FOOTER //
// ./src/Dashboard/index.js